import { render, staticRenderFns } from "./receive-code.vue?vue&type=template&id=9b692506&scoped=true&"
import script from "./receive-code.vue?vue&type=script&lang=js&"
export * from "./receive-code.vue?vue&type=script&lang=js&"
import style0 from "./receive-code.vue?vue&type=style&index=0&id=9b692506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b692506",
  null
  
)

export default component.exports